import type { MsFoundationItem } from '@/domains/esg/key-activities/components/MsFoundation/MsFoundationItem.types'
import type { MultiuczynekItem } from '@/domains/esg/key-activities/components/Multiuczynek/MultiuczynekItem.types'

export const useKeyActivities = () => {

  const { t } = useI18n()

  const msFoundationItems: MsFoundationItem[] = [
    {
      title: t('keyActivities.foundation.item1.title'),
      text: t('keyActivities.foundation.item1.text'),
      image: {
        alternative: t('keyActivities.foundation.item1.title'),
        url: '/images/key-activities/active-multisport-schools.webp',
        urlMobile: '/images/key-activities/active-multisport-schools__m.webp',
      },
      icon: {
        alternative: '',
        url: '/images/key-activities/active-multi-sport-schools-icon.png',
      },
    },
    {
      title: t('keyActivities.foundation.item2.title'),
      text: t('keyActivities.foundation.item2.text'),
      image: {
        alternative: t('keyActivities.foundation.item1.title'),
        url: '/images/key-activities/multisport-classes.webp',
        urlMobile: '/images/key-activities/multisport-classes__m.webp',
      },
      icon: {
        alternative: '',
        url: '/images/key-activities/multisport-classes-icon.png',
      },
    },
    {
      title: t('keyActivities.foundation.item3.title'),
      text: t('keyActivities.foundation.item3.text'),
      image: {
        alternative: t('keyActivities.foundation.item3.title'),
        url: '/images/key-activities/full-of-sport.webp',
        urlMobile: '/images/key-activities/full-of-sport__m.webp',
      },
      icon: {
        alternative: '',
        url: '/images/key-activities/full-of-sport-icon.png',
      },
    },
    {
      title: t('keyActivities.foundation.item4.title'),
      text: t('keyActivities.foundation.item4.text'),
      image: {
        alternative: t('keyActivities.foundation.item4.title'),
        url: '/images/key-activities/senior-in-good-shape.webp',
        urlMobile: '/images/key-activities/senior-in-good-shape__m.webp',
      },
      icon: {
        alternative: '',
        url: '/images/key-activities/senior-in-good-shape-icon.png',
      },
    },
  ]

  const multiuczynekItems: MultiuczynekItem[] = [
    {
      title: t('keyActivities.multiuczynek.item1.title'),
      text: t('keyActivities.multiuczynek.item1.text'),
      icon: {
        alternative: '',
        url: '/images/key-activities/multiuczynek-animals.png',
        urlMobile: '/images/key-activities/multiuczynek-animals__m.png',
      },
    },
    {
      title: t('keyActivities.multiuczynek.item2.title'),
      text: t('keyActivities.multiuczynek.item2.text'),
      icon: {
        alternative: '',
        url: '/images/key-activities/multiuczynek-local-communities.png',
        urlMobile: '/images/key-activities/multiuczynek-local-communities__m.png',
      },
    },
    {
      title: t('keyActivities.multiuczynek.item3.title'),
      text: t('keyActivities.foundation.item3.text'),
      icon: {
        alternative: '',
        url: '/images/key-activities/multiuczynek-environmental-protection.png',
        urlMobile: '/images/key-activities/multiuczynek-environmental-protection__m.png',
      },
    },
  ]

  const goodHabitsItems = [
    {
      'url': t('keyActivities.goodHabits.items[3].image.url'),
      'alternative': t('keyActivities.goodHabits.items[3].image.alternative'),
      'width': '1200',
      'height': '1200',
    },
    {
      'url': t('keyActivities.goodHabits.items[0].image.url'),
      'alternative': t('keyActivities.goodHabits.items[0].image.alternative'),
      'width': '1200',
      'height': '1200',
    },
    {
      'url': t('keyActivities.goodHabits.items[1].image.url'),
      'alternative': t('keyActivities.goodHabits.items[1].image.alternative'),
      'width': '1200',
      'height': '1200',
    },
    {
      'url': t('keyActivities.goodHabits.items[2].image.url'),
      'alternative': t('keyActivities.goodHabits.items[2].image.alternative'),
      'width': '1200',
      'height': '1200',
    },

    {
      'url': t('keyActivities.goodHabits.items[4].image.url'),
      'alternative': t('keyActivities.goodHabits.items[4].image.alternative'),
      'width': '1200',
      'height': '1200',
    },
  ]

  return {
    msFoundationItems,
    multiuczynekItems,
    goodHabitsItems,
  }
}
